import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @file Card 卡片布局组件
 */
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { isString } from '@seiue/util';
import classnames from 'classnames';
import React from 'react';
import styled, { css } from 'styled-components';
import { Divider } from '../Divider';
import { Ellipsis } from '../Ellipsis';
import { Icon } from '../Icon';
const sectionDividerClassName = 'card-section-divider';
export const Card = ({ style, className, headerStyle, contentStyle, type = 'default', title, headerRight, children, collapsable = false, onClick, smallTitle = false, onMouseEnter, onMouseLeave, }) => {
    const [collapsed, setCollapsed] = React.useState(false);
    const showHeader = !!(title || headerRight);
    return (_jsxs(CardWrapper, Object.assign({ className: classnames(['seiue-card', className]), style: style, type: type, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, { children: [showHeader ? (_jsxs(HeaderWrapper, Object.assign({ collapsable: collapsable, onClick: () => {
                    if (collapsable)
                        setCollapsed(!collapsed);
                } }, { children: [!!title && !isString(title) ? (title) : (_jsxs(Header, Object.assign({ type: type, smallTitle: smallTitle, style: headerStyle, collapsable: collapsable }, { children: [!title ? (_jsx("span", {}, void 0) // hold place for headerRight
                            ) : (_jsx(Ellipsis, { text: title }, void 0)), headerRight] }), void 0)), collapsable ? (
                    // collapsed type cannot be Boolean: https://styled-components.com/docs/faqs#why-am-i-getting-html-attribute-warnings
                    _jsx(ExpandIcon, { icon: faChevronDown, color: "rgba(6, 12, 25, 0.45)", collapsed: collapsed ? 1 : 0 }, void 0)) : null] }), void 0)) : null, (type === 'divided' || collapsable) && !collapsed ? _jsx(Divider, {}, void 0) : null, _jsx(Content, Object.assign({ type: type, collapsed: collapsed, style: contentStyle, showHeader: showHeader, collapsable: collapsable, className: "seiue-card-content" }, { children: children }), void 0), type === 'section' && (_jsx(SectionDivider, { className: sectionDividerClassName }, void 0))] }), void 0));
};
const CardWrapper = styled.div `
  position: relative;
  display: block;
  background-color: ${'#fff'};
  border-radius: 6px;
  overflow: hidden;

  ${p => p.onClick &&
    css `
      cursor: pointer;
    `};

  ${({ type }) => type !== 'section' &&
    css `
      box-shadow: 0 3px 16px 0px rgba(50, 56, 66, 0.04);
    `}
  &:not(:last-child) {
    margin-bottom: ${({ type }) => (type !== 'section' ? '16px' : 0)};
  }

  /* no section-divider for last section card */
  ${({ type }) => type === 'section' &&
    css `
      &:last-child .${sectionDividerClassName} {
        display: none;
      }
    `}
`;
const HeaderWrapper = styled.div `
  ${props => props.collapsable &&
    css `
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
    `}
`;
const Header = styled.div `
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  height: 58px;
  padding: 0 24px;
  padding-top: ${({ type, collapsable }) => (type === 'default' || type === 'section') && !collapsable ? '8px' : '0'};
  color: rgba(6, 12, 25, 0.85);
  font-weight: bold;
  font-size: ${({ smallTitle, type }) => {
    if (smallTitle)
        return '14px';
    if (type === 'section')
        return '16px';
    return '18px';
}};
`;
const ExpandIcon = styled(Icon) `
  position: relative;
  margin-right: 24px;
  transform: ${props => (props.collapsed ? 'rotate(180deg)' : 'rotate(0)')};
  cursor: pointer;
  transition: transform 0.3s;
`;
const Content = styled.div `
  height: ${({ collapsed }) => (collapsed ? 0 : 'auto')};
  padding: ${({ type, collapsed }) => {
    if (collapsed)
        return 0;
    switch (type) {
        case 'section-list':
            return 0;
        default:
            return '24px';
    }
}};

  ${({ showHeader, type, collapsable }) => 
// no padding-top for Content when showing header
showHeader &&
    type !== 'divided' &&
    !collapsable &&
    css `
      padding-top: 0;
    `}
  overflow: hidden;
`;
const SectionDivider = styled(Divider) `
  &&& {
    width: auto;
    min-width: auto;
    margin: 0 24px 8px 24px;
  }
`;
//# sourceMappingURL=data:application/json;base64,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